import React from "react";

export default class Tooltip extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			show: false,
			title: '',
			height: 0,
			width: 0,
			top: 0,
			left: 0
		}
	}

	ref = null
	refChild = null
	componentDidMount() {
		window.addEventListener('resize', this.handleResize)
		this.handleResize()
	}

	handleResize = () => {
		if (this.ref && this.refChild) {
			setTimeout(() => {
				const height = this.ref.clientHeight;
				const width = this.ref.clientWidth;
				const bound = this.refChild.getBoundingClientRect();
				const top = bound.top;
				const left = bound.left;
				this.setState({height, width, top, left, title: this.props.title})
			}, 50)
		}
	}

	render() {
		if (this.state.title !== this.props.title) {
			this.handleResize()
		}
		return (
			<div
				style={{ position: 'relative' }}
				onMouseEnter={() => this.setState({ show: true })}
				onMouseLeave={() => this.setState({ show: false })}
			>
				<div ref={(divElement) => { this.ref = divElement }} style={{
					position: 'fixed',
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'center',
					backgroundColor: '#000000',
					opacity: 0.85,
					color: '#FFFFFF',
					visibility: (this.state.show) ? 'visible' : 'hidden',
					padding: 5,
					borderRadius: 5,
					top: (this.state.top - 5 - this.state.height),
					left: (this.state.left + 70 - this.state.width),
					zIndex: 1000,
					overflow: 'hidden'
				}}>
					<div style={{ display: 'flex', flexDirection: 'column', marginRight: 10 }}>
						<div style={{ fontSize: 22, fontWeight: 600, whiteSpace: 'nowrap' }}>{this.props.title}</div>
						{this.props.text}
					</div>
					<div style={{ fontSize: 26, fontWeight: 600 }}>
						{this.props.price}
					</div>
				</div>
				<div ref={(divElement) => { this.refChild = divElement }} >
					{this.props.children}
				</div>
			</div>
		)
	}
}